import { useCallback } from 'react';
import { useReactFlow } from '@xyflow/react';

/**
 * 在 nowheel 元素上实现 Ctrl+滚轮缩放画布。
 * 当用户按住 Ctrl 滚动滚轮时，以鼠标位置为中心缩放画布；
 * 不按 Ctrl 时保持原始滚动行为。
 */
export function useCtrlWheelZoom() {
  const { setViewport, getViewport } = useReactFlow();

  const handleWheel = useCallback(
    (e: React.WheelEvent) => {
      if (!e.ctrlKey && !e.metaKey) return;

      e.preventDefault();
      e.stopPropagation();

      const viewport = getViewport();
      const currentZoom = viewport.zoom;

      // 计算缩放因子
      const factor = e.deltaY > 0 ? 0.9 : 1.1;
      const nextZoom = Math.max(0.1, Math.min(3, currentZoom * factor));

      // 获取 ReactFlow 容器的位置（即画布视口）
      const flowContainer = (e.currentTarget as HTMLElement).closest('.react-flow') as HTMLElement;
      if (!flowContainer) return;

      const containerRect = flowContainer.getBoundingClientRect();
      // 鼠标在画布容器中的位置
      const mouseX = e.clientX - containerRect.left;
      const mouseY = e.clientY - containerRect.top;

      // 以鼠标位置为中心缩放：计算新的视口偏移
      // flowX = (mouseX - viewportX) / currentZoom  (鼠标在 flow 坐标系中的位置，不变)
      // viewportX_new = mouseX - flowX * nextZoom
      const flowX = (mouseX - viewport.x) / currentZoom;
      const flowY = (mouseY - viewport.y) / currentZoom;

      const newX = mouseX - flowX * nextZoom;
      const newY = mouseY - flowY * nextZoom;

      setViewport({ x: newX, y: newY, zoom: nextZoom }, { duration: 0 });
    },
    [setViewport, getViewport],
  );

  return handleWheel;
}
